/*============================================================================
CoAttend robust sold-out handling for swatches
==============================================================================*/
(function(){
  // Global capture listener: blocks clicks on sold-out coattend buttons
  document.addEventListener('click', function(e){
    const btn = e.target.closest && e.target.closest('.coattend-button');
    if (!btn) return;
    // block if we have explicitly marked it as disabled/sold-out
    if (btn.dataset.coattendDisabled === 'true' || btn.disabled) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // use capture so we run before other listeners

  function getProductData() {
    // try ProductJson script first (has `available`), otherwise fallback to window.meta / window.product
    const productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (productJsonEl) {
      try { return JSON.parse(productJsonEl.textContent); } catch (err) { console.error('ProductJson parse error', err); }
    }
    if (window.meta && window.meta.product) return window.meta.product;
    if (window.product) return window.product;
    return null;
  }

  function updateCoattendButton() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (!variantId) return;

    const productData = getProductData();
    let variantData = null;
    if (productData && productData.variants) {
      variantData = productData.variants.find(v => String(v.id) === String(variantId));
    }

    document.querySelectorAll('.coattend-button').forEach(button => {
      const coattendEventData = window.coattend_event_data;

      if (variantData && !variantData.available && (!coattendEventData.has_waitlist && variantData.id !== coattendEventData.variant_id)) {
        // SOLD OUT state
        button.disabled = true;
        button.dataset.coattendDisabled = 'true'; // used by the capture listener
        button.removeAttribute('data-coattend-variant-id'); // optional: avoid other scripts using it
        button.removeAttribute('data-coattend-waitlist');
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Sold out';

        // visual styling (red background, white text)
        button.style.backgroundColor = '#868585';
        button.style.borderColor = '#868585';
        button.style.color = 'white';
        button.style.pointerEvents = 'none'; // prevents mouse interactions too
        button.classList.add('cursor-not-allowed', 'opacity-80');
      } else if (coattendEventData && coattendEventData.has_waitlist && variantData && variantData.id === coattendEventData.variant_id && !variantData.available) {
        // WAITLIST state
        button.disabled = false;
        button.dataset.coattendDisabled = 'false';
        button.setAttribute('data-coattend-variant-id', variantId);
        button.setAttribute('data-coattend-waitlist', true);
        button.removeAttribute('aria-disabled');
        button.textContent = 'Join Waitlist';

        // reset visual styling
        button.style.backgroundColor = 'black';
        button.style.borderColor = 'black';
        button.style.color = 'white';
        button.style.pointerEvents = '';
        button.classList.remove('cursor-not-allowed', 'opacity-80');
      } else {
        // AVAILABLE state
        button.disabled = false;
        button.dataset.coattendDisabled = 'false';
        button.setAttribute('data-coattend-variant-id', variantId);
        button.removeAttribute('data-coattend-waitlist');
        button.removeAttribute('aria-disabled');
        button.textContent = 'Book now';

        // reset visual styling
        button.style.backgroundColor = 'black';
        button.style.borderColor = 'black';
        button.style.color = 'white';
        button.style.pointerEvents = '';
        button.classList.remove('cursor-not-allowed', 'opacity-80');
      }
    });
  }

  // run on load (safe if DOMContentLoaded already fired)
  document.addEventListener('DOMContentLoaded', updateCoattendButton);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    updateCoattendButton();
  }

  // run on swatch/variant changes
  document.querySelectorAll('.dynamic-variant-input').forEach(select => {
    select.addEventListener('change', () => {
      setTimeout(updateCoattendButton, 100);
    });
  });
})();
